var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vps-detail-view"},[_c('transition',{attrs:{"name":"bubble"}},[_c('page-block',{staticClass:"vps-detail-view__block"},[_c('tariffs-table-snapshots',{attrs:{"dataset":_vm.tariff}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }